import axios from 'axios'
import { logger } from 'shared/lib/logger'

export const getClientIpAddress: () => Promise<string | null> = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json')
    return response.data.ip || null
  } catch (error) {
    logger.error(error)
    return null
  }
}
